export const AnchorPointX = 14;
export const AnchorPointY = 36;
export const DEFAULT_ICON_PATH = './assets/custom-map-pin.svg';
